var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 6.4L20 5.6L18.4 4.00471L17.6 4.80471L12 10.4047L6.4 4.8L5.6 4L4.00471 5.6L4.80471 6.4L10.4047 12L4.8 17.6L4 18.4L5.6 19.9953L6.4 19.1953L12 13.5953L17.6 19.2L18.4 20L19.9953 18.4L19.1953 17.6L13.5953 12L19.2 6.4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.8c1825584e0000d8023374f6afb3529d.svg";
export { ForwardRef as ReactComponent };